import React, { Component } from 'react'
import { StaticBox, FlowTable, Modal, LinkedInputGroup, LinkedInput, NoContentBox } from 'components/basic'
import { date, notify } from 'helpers'
import Datetime from 'react-datetime'
import { default as moment } from 'moment-timezone'
import http from 'API/http'
import { Installation } from 'config'
import ReactHtmlParser from 'react-html-parser'

class AvailableServices extends Component {
  constructor (props) {
    super(props)
    this.state = {
      access: null,
      connectionModal: false,
      activationDate: null,
      serviceToConnect: {},
      commentsModal: false,
      comments: [],
      limeTicketOrderModal: false,
      limeOrderCreateTicket: false
    }
  }
  componentDidMount () {
    this.setServices(this.props.access)
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return false
    this.setServices(props.access)
  }
  setServices (access) {
    this.setState({access})
  }

  checkLimeCreateTicket () {
    console.log('connect', this.state.serviceToConnect)
    this.setState({limeOrderCreateTicket: (Installation.enable.createLimeOrderTicket && this.state.serviceToConnect.comments && this.state.serviceToConnect.comments[0])})
  }

  async createLimeTicket (service) {
    // Lime uses 2.3 backend, 2.4-version is work in progress
    var [err, res] = await http.post('2.3/tickets', {
      title: 'lime_order',
      description: JSON.stringify(
        {
          'service': service,
          'customerName': this.state.customerName,
          'customerNumber': this.state.customerNumber,
          'customerEmail': this.state.customerEmail
        }),
      accessId: this.state.access.accessId,
      state: {'status': 'LIME_ORDER'}
    })

    if (err) return notify.alert('', err.response.data.cause, 'error')
    this.setState({limeTicketOrderModal: true, customerEmail: '', customerName: '', customerNumber: ''})
  }

  getServiceAvailability (availability) {
    if (availability === 'YES') return <span className='label orders-label label-success'><b>YES</b></span>
    if (availability === 'NO') return <span className='label orders-label label-danger'><b>NO</b></span>
    return <span className='label orders-label label-primary'><b>{date.format(availability)}</b></span>
  }
  async openConnectionModal (service) {
    this.setState({serviceToConnect: service, connectionModal: true}, this.checkLimeCreateTicket)
    if (service.available !== 'YES' && service.available !== 'NO') this.setState({activationDate: moment(service.available)})
  }
  isDateValidActivate (current) {
    var yesterday = Datetime.moment().subtract(1, 'day')
    if (this.state.serviceToConnect.available !== 'YES' && this.state.serviceToConnect.available !== 'NO') {
      return current.isSameOrAfter(moment(this.state.serviceToConnect.available))
    }
    return current.isAfter(yesterday)
  }
  async activateService () {
    let service = this.state.serviceToConnect.service
    var valid = await new Promise((resolve, reject) => { this.form.check(resolve) })
    if (!valid) return
    this.setState({activating: true})
    //eslint-disable-next-line
    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.access.accessId,
      service: this.state.serviceToConnect.service,
      requestedDateTime: (this.state.activationDate ? moment(this.state.activationDate).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]') : moment().utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')),
      operation: 'ACTIVATE',
      forcedTakeover: false,
      equipment: [
        { vendorId: 'CH_BROADBAND' }
      ],
      spReference: this.state.spReference,
      spSubscriptionId: this.state.spSubscriptionId
    })
    var activationDate = this.state.activationDate
    this.setState({
      activationDate: null,
      serviceToConnect: {},
      connectionModal: false,
      spReference: '',
      spSubscriptionId: '',
      activating: false
    })
    if (err) return notify.alert('', err.response.data.cause, 'error')
    notify.alert('', 'The service will be activated ' + (!activationDate ? 'soon.' : moment(activationDate).format('YYYY-MM-DD HH:mm')), 'success')

    if (this.state.limeOrderCreateTicket) {
      this.createLimeTicket(service)
    }

    this.props.callback()
  }
  render () {
    if (!this.state.access) return false
    return (
      <div>
        <StaticBox cols={12} icon='cog' title='Available Services'>
          <FlowTable data={this.state.access.services.map(service => [
            (service.available !== 'NO' && <a onClick={e => this.openConnectionModal(service)} className='table-link'><i className='fa fa-plus' /></a>),
            this.getServiceAvailability(service.available),
            service.service,
            service.comments && service.comments.length > 1 && <a data-tip='View All Comments' onClick={e => this.setState({comments: service.comments, commentsModal: true})} className='table-link'><i className='fa fa-comments-o' /></a>,
            service.comments && service.comments[0]
          ])}>
            <tr>
              <th className='buttons' />
              <th style={{'width': '60px'}}>Available</th>
              <th>Name</th>
              <th className='buttons' />
              <th>Comment</th>
            </tr>
          </FlowTable>
        </StaticBox>
        <Modal noOverflow title={'Connect ' + this.state.serviceToConnect.service} isOpen={this.state.connectionModal} close={e => this.setState({connectionModal: false})} buttons={[
            { text: 'Cancel', event: e => this.setState({connectionModal: false, connect: {}}), hidden: this.state.activating },
            { text: 'Connect', event: e => this.activateService(), hidden: this.state.activating }
        ]}>
          <label>Activation time</label>
          <Datetime isValidDate={this.isDateValidActivate.bind(this)} value={this.state.activationDate} onChange={date => {
            this.setState({activationDate: date})
          }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
              <input {...props} className='form-control' />
            </div>
          } />
          {this.state.limeOrderCreateTicket &&
            <LinkedInputGroup ref={(form) => { this.form = form }}>
              <div className='row'>
                <div className='col-md-12'>
                  <label>Your Internal Reference</label>
                  <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='spReference' />
                </div>
                <div className='col-md-12'>
                  <label>Your Subscription ID</label>
                  <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='spSubscriptionId' />
                </div>
                <div className='col-md-12'>
                  <label>Customer name</label>
                  <LinkedInput validate={/\w{1,}/i} errorMessage='This field is required' context={this} path='customerName' />
                </div>
                <div className='col-md-12'>
                  <label>Customer contact number</label>
                  <LinkedInput validate={/\w{1,}/i} errorMessage='This field is required' context={this} path='customerNumber' />
                </div>
                <div className='col-md-12'>
                  <label>Customer email</label>
                  <LinkedInput validate={/\w{1,}/i} errorMessage='This field is required' context={this} path='customerEmail' />
                </div>
              </div>
            </LinkedInputGroup>
          }
          {!this.state.limeOrderCreateTicket &&
            <LinkedInputGroup ref={(form) => { this.form = form }}>
              <div className='row'>
                <div className='col-md-12'>
                  <label>Your Internal Reference</label>
                  <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='spReference' />
                </div>
                <div className='col-md-12'>
                  <label>Your Subscription ID</label>
                  <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='spSubscriptionId' />
                </div>
              </div>
            </LinkedInputGroup>
          }
          {this.state.activating && <NoContentBox icon='circle-o-notch fa-spin' text='' />}
        </Modal>
        <Modal noOverflow icon='comments-o' title='Comments' isOpen={this.state.commentsModal} close={e => this.setState({commentsModal: false})}>
          {this.state.comments && this.state.comments.map(comment => {
            return (
              <div className='col-md-12'>
                <pre>
                  {comment}
                </pre>
              </div>
            )
          })}
        </Modal>
        <Modal title='' isOpen={this.state.limeTicketOrderModal} close={e => this.setState({limeTicketOrderModal: false})}>
          {ReactHtmlParser(Installation.limeTicketOrderMessage)}
        </Modal>
      </div>
    )
  }
}
export default AvailableServices



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/access/AvailableServices.js